const DEFAULT_EMPTY_EMAIL = {
        id: null,
        recipients: [],
        cc: [],
        bcc: [],
        subject: "",
        body: ""

}

const DEFAULT_CASE_FOLDERS = [
        {name : "radni", file_type_allowed : "*"}, {name : "spisi",
        file_type_allowed : ".pdf"},  {name : "komunikacija",
        file_type_allowed : ".pdf"}]


const GLOBAL_LOADER_VALUE = "Učitavanje podataka..."
        
export {DEFAULT_EMPTY_EMAIL,DEFAULT_CASE_FOLDERS,
        GLOBAL_LOADER_VALUE}